import React, { useEffect, useState } from "react";
import MainLayout from "../../components/layout/layout";
import {
  LargeHeadline,
  LabelText,
  MediumText,
} from "../../components/typography";
import Input from "../../components/ui/inputs";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import googleIcon from "../../assets/images/icons/google-icon.svg";
import { BodyBlock, LightText } from "./sign-in";
import { useNavigate } from "react-router-dom";
import { API_URL_AUTH } from "../../constants";
import toast from "react-hot-toast";
import { AuthModeEnum } from "../../assets/utils/validation/types";
import { useAuthValidation } from "../../assets/utils/hooks/useAuthValidation";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";

const SignUpPage: React.FC = () => {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const { errors, validate } = useAuthValidation();
  const navigate = useNavigate();

  const [loaderState, setLoaderState] = useState<boolean>(false);

  async function register() {
    try {
      setLoaderState(true);

      const { hasErrors } = validate(
        { firstName, lastName, email, phone, password, confirmPassword },
        AuthModeEnum.REGISTER
      );
      if (hasErrors) return;
      
      const response = await fetch(`${API_URL_AUTH}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ firstName, lastName, email, phone, password }),
        credentials: "include",
      });

      const text = await response.text();

      if (!response.ok) {
        console.error("Server error:", text);
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.ERROR}
            text={text.split("\n")[0].split("System.Exception:")[1]?.trim() || "Помилка реєстрації"}
          />
        ));
        return;
      }

      try {
        toast((t) => (
          <CustomToast
            t={t}
            type={
              response.status === 200
                ? ToastTypeEnum.SUCCESS
                : ToastTypeEnum.ERROR
            }
            text={
              response.status === 200
                ? "Успішний реєстрація."
                : "Помилка реєстрації."
            }
          />
        ));

        navigate("/sign-in");
      } catch (jsonErr) {
        console.error("Не JSON відповідь:", text);
      }
    } catch (error) {
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.ERROR}
          text={"Упс, щось пішло не так"}
        />
      ));
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 1000);
    }
  }

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        register();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, password, firstName, lastName, phone, confirmPassword]);

  return (
    <MainLayout
      className="d-flex flex-column align-items-center"
      loaderState={loaderState}
    >
      <BodyBlock>
        <LargeHeadline>Створити акаунт</LargeHeadline>
        <span className="w-100 d-flex gap-sm-3 flex-sm-row flex-column">
          <Input
            attribute="first-name"
            value={firstName}
            setValue={setFirstName}
            errorText={errors?.firstName!}
            label="Ім'я"
            placeholder="Ім'я"
          />
          <Input
            attribute="last-name"
            value={lastName}
            setValue={setLastName}
            errorText={errors?.lastName!}
            label="Прізвище"
            placeholder="Прізвище"
          />
        </span>
        <Input
          attribute="email"
          value={email}
          setValue={setEmail}
          errorText={errors?.email!}
          label="Електронна пошта"
          placeholder="Example@gmail.com"
        />
        <Input
          attribute="phone"
          value={phone}
          setValue={setPhone}
          errorText={errors?.phone!}
          label="Номер телефону"
          placeholder="Example@gmail.com"
        />
        <Input
          attribute="password"
          value={password}
          setValue={setPassword}
          errorText={errors?.password!}
          label="Пароль"
          placeholder="Введіть пароль"
        />
        <Input
          attribute="passwordConfirm"
          value={confirmPassword}
          setValue={setConfirmPassword}
          errorText={errors?.confirmPassword!}
          label="Підтвердіть пароль"
          placeholder="Введіть пароль"
        />
        <Button
          bgcolor={COLORS.blue}
          txtcolor={COLORS.white}
          brcolor={"transparent"}
          width="100%"
          className="mt-3"
          type="large"
          onClick={register}
        >
          <LabelText>Зареєструватися</LabelText>
        </Button>
        <Button
          bgcolor={"transparent"}
          txtcolor={COLORS.secondary1}
          brcolor={COLORS["bg-text-color"]}
          width="100%"
          type="large"
          onClick={() =>
            (window.location.href =
              "http://back.galera.fm/api/auth/google/login")
          }
          className="d-flex align-items-center justify-content-center gap-2 mt-2"
        >
          <img src={googleIcon} alt="google-icon" />
          <LabelText>Зареєструватися через Google</LabelText>
        </Button>
        <span className="d-flex align-items-center pt-1 cursor-pointer">
          <LightText>Вже маєте акаунт?</LightText>
          <Button
            bgcolor={"transparent"}
            txtcolor={COLORS.blue}
            brcolor={"transparent"}
            width="auto"
            type="large"
            onClick={() => navigate("/sign-in")}
          >
            <MediumText>Увійдіть</MediumText>
          </Button>
        </span>
      </BodyBlock>
    </MainLayout>
  );
};

export default SignUpPage;
